import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationsListComponent } from './components/organizations-list/organizations-list.component';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {NgxPaginationModule} from 'ngx-pagination';
import {RouterModule} from '@angular/router';
import { CategorizeTabListComponent } from './components/categorize-tab-list/categorize-tab-list.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ImageUploaderModalComponent } from './components/image-uploader-modal/image-uploader-modal.component';
import {ImageCropperComponent} from 'ngx-image-cropper';



@NgModule({
  declarations: [OrganizationsListComponent, CategorizeTabListComponent, ImageUploaderModalComponent],
  exports: [
    OrganizationsListComponent,
    CategorizeTabListComponent,
    ImageUploaderModalComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    NgxPaginationModule,
    RouterModule,
    MatTabsModule,
    ImageCropperComponent
  ]
})
export class CommonComponentModule { }
